import { Component, OnDestroy, OnInit, Output } from '@angular/core';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { ResponseMsgUtils } from '../../../../../sg-ke-shared/util/response-msg-utils';
import { Sgke032aResponseMiseisanInfo } from 'sg-api';

@Component({
  selector: 'app-sgke060d',
  templateUrl: './sgke060d.component.html',
  styleUrl: './sgke060d.component.scss'
})
export class Sgke060dComponent implements OnInit, OnDestroy {
  /** メッセージエリア */
  @Output() errorMessageModelArray: Array<SgAriaMessage> = new Array<SgAriaMessage>();

  /** 返金結果登録ラジオボタン */
  registType: string = '';

  /** 請求お客さま番号 */
  recptFixNo: string = '100000000000001';
  /** 未精算金管理番号 */
  kinkoMno: string = '200000000000001';
  /** 未精算金履歴番号 */
  kinkoRrkno: string = '3001';
  /** 返金管理番号 */
  repayMno: string = '400000000000001';
  /** 未精算金_更新通番号 */
  kinkoUpdateSrno: string = '50001';
  /** 未精算金EX_更新通番号 */
  kinkoexUpdatesequencenumber: string = '60001';

  /**
   * コンストラクタ
   * @param {ResponseMsgUtils} responseMsgUtils
   * @memberof Sgke060dComponent
   */
  constructor(
    public responseMsgUtils: ResponseMsgUtils,
  ) { }

  /**
   * 初期処理
   * @memberof Sgke060dComponent
   */
  ngOnInit(): void {
  }
  /**
   * 購読解除
   * @memberof Sgke060dComponent
   */
  ngOnDestroy() {
  }


  /**
   * ラジオボタン押下時(sgke020dから呼ばれる再現)
   * @param {*} event
   * @memberof Sgke060dComponent
   */
  onChangeRadio(event: string): void {
    this.registType = event;
  }

  /**
   * sgke020d再描画再現
   * @memberof Sgke060dComponent
   */
  public search(miseisanInfo: Sgke032aResponseMiseisanInfo = null) {

    this.kinkoMno = miseisanInfo.kinkoMno;
    this.kinkoRrkno = miseisanInfo.kinkoRrkno;

    this.registType = "";
  }

  /**
   * 正常メッセージ出力
   * @param {string} message
   * @memberof Sgke060dComponent
   */
  public showNormalMsg(message: string): void {

    this.errorMessageModelArray = new Array<SgAriaMessage>;
    // メッセージオブジェクトを作成
    let messageItem: SgAriaMessage = {
      message: message,
      messageClass: "mat-card-background-primary",
      icon: "done",
      iconClass: "mat-icon-color-primary"
    };

    // errorMessageModelArrayにメッセージオブジェクトを追加
    this.errorMessageModelArray.push(messageItem);
  }

  /**
   * エラーメッセージ出力
   *
   * @param {string} message
   * @memberof Sgke060dComponent
   */
  public showErrorMsg(message: string): void {

    this.errorMessageModelArray = new Array<SgAriaMessage>;
    // メッセージオブジェクトを作成
    let messageItem: SgAriaMessage = {
      message: message,
      messageClass: "mat-card-background-error",
      icon: "cancel",
      iconClass: "mat-icon-color-error"
    };

    // errorMessageModelArrayにメッセージオブジェクトを追加
    this.errorMessageModelArray.push(messageItem);
  }

  /**
   * エラーメッセージ表示
   * @memberof Sgke060dComponent
   */
  showMsg(errors) {
    // メッセージを表示
    this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(errors, this.errorMessageModelArray);
  }

  /**
   * エラーメッセージ表示領域をクリア
   * @memberof Sgke060dComponent
   */
  public clearErrorMsg() {
    if (this.errorMessageModelArray) {
      this.errorMessageModelArray.length = 0;
    }
  }
}
